import React, { useEffect, useState } from "react";
import { Box, Table, Thead, Tbody, Tr, Th, Td, Select, Spinner, useColorModeValue } from "@chakra-ui/react";
import axios from "axios";

const TableComment = ({ selectedRetailer, selectedSupplier, weekEndingDates, ddStrikeRate, weekEndingDate, comment, search }) => {
  const [TheadData, setTheadData] = useState([]);
  const [TbodyData, setTbodyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const theadBg = useColorModeValue("gray.50", "gray.700");

  const fetchTableComment = async (wed, cmt, srch) => {
    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/rep_strikeRate/get-table-comment`, {
        retailer: selectedRetailer,
        supplier: selectedSupplier,
        week_ending_date: wed,
        comment: cmt,
        search: srch,
      });
      setTheadData(res.data.data.tableData.thead);
      setTbodyData(res.data.data.tableData.tbody);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching comment table data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (weekEndingDates.length > 0 && weekEndingDate) {
      fetchTableComment(weekEndingDate, comment, search);
    }
  }, [selectedRetailer, selectedSupplier, weekEndingDates, weekEndingDate, comment, search]);

  const postReason = async (row) => {
    const payload = {
      retailer: selectedRetailer,
      supplier: selectedSupplier,
      week_ending_date: row.week_ending_date,
      site_code: row.site_code,
      article_code: row.article_code,
      reason_uuid: row.reason_uuid,
    };
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/rep_strikeRate/save-reason`, payload);
      if (!res.data.status) {
        console.warn("Failed to update reason. Response:", res);
      }
    } catch (error) {
      console.error("Error updating reason:", error);
    }
  };

  const handleReasonChange = async (e, row) => {
    const reason_uuid = e.target.value;
    const updatedRow = { ...row, reason_uuid };
    await postReason(updatedRow);
    setTbodyData((prevData) => prevData.map((r) => (r.week_ending_date === row.week_ending_date && r.site_code === row.site_code && r.article_code === row.article_code ? updatedRow : r)));
  };

  function formatDateString(dateString) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month} '${year}`;
  }

  if (loading) return <Spinner />;

  return (
    <Box overflowY="auto" maxH="calc(70vh - 60px)">
      <Table variant="striped" size="sm" colorScheme="custom">
        <Thead position="sticky" top={0} zIndex={1} bg={theadBg}>
          {TheadData.map((row, index) => (
            <Tr key={index}>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th1}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th2}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th3}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th4}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th5}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th6}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th7}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th8}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th9}</Th>
              <Th fontSize="xs" whiteSpace="nowrap">{row.th10}</Th>
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {TbodyData.map((row, index) => (
            <Tr key={index}>
              <Td fontSize="xs" whiteSpace="nowrap">{formatDateString(row.week_ending_date)}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.po_code}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.site_code}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.site_description}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.article_code}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.article_description}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.order_qty}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.receipt_qty}</Td>
              <Td fontSize="xs" whiteSpace="nowrap">{row.strike_rate_percentage}</Td>
              <Td fontSize="xs" whiteSpace="nowrap" p={0}>
                <Select size="xs" defaultValue={row.reason_uuid} onChange={(e) => handleReasonChange(e, row)}>
                  {ddStrikeRate.map((item) => (
                    <option key={item.uuid} value={item.uuid}>
                      {item.text}
                    </option>
                  ))}
                </Select>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default TableComment;
